import React, { memo } from 'react';
import classnames from 'classnames';

import { isMediaQuery } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import { isTouch } from '~/core/scripts/utils';
import SegmentInfo from '~/kits/general/scripts/SegmentInfo';

import './tooltip.styl';

const Tooltip = memo(({ data, isStatic, dataRel, pos, isVisible, onClose, segmentName, segmentData }) => {
  if (!data || (!pos && !isStatic)) {
    return null;
  }

  const style = isMediaQuery(768) && !isStatic ? { left: `${pos.x}px`, top: `${pos.y}px` } : {};
  const isInverted = isStatic ? false : pos.x >= window.innerWidth / 2;
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted, segmentName });
  const isClosable = !isStatic && (isTouch || !isMediaQuery(768));

  const handleClose = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    onClose();
  };

  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        {isClosable && (
          <button className="btn close" onClick={handleClose}>
            <Icon type="close" />
          </button>
        )}
        <SegmentInfo
          segmentName={segmentName}
          dataRel={dataRel}
          segmentData={segmentData}
          colorDark={data.colorDark}
          color={data.color}
          colorBright={data.colorBright}
        />
      </div>
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
